var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcFooterView(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "13px",
    viewBox: "0 0 23 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icFooterView") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8588571,5.60390625 C22.1718333,5.90859375 22.3441667,6.315625 22.3441667,6.74973958 C22.3444286,7.18411458 22.1720952,7.59114583 21.859119,7.89609375 C20.3361429,9.37890625 16.2781905,12.8278646 11.5,12.8278646 C6.72154762,12.8278646 2.66385714,9.37916667 1.14114286,7.89635417 C0.827904762,7.59140625 0.655571429,7.184375 0.655833333,6.75 C0.655833333,6.315625 0.828166667,5.90885417 1.14114286,5.60416667 C2.66385714,4.12135417 6.72180952,0.672135417 11.5,0.672135417 C16.2779286,0.672135417 20.335881,4.12109375 21.8588571,5.60390625 Z M11.5,3.10703125 C9.47966667,3.10703125 7.83621429,4.74114583 7.83621429,6.75 C7.83621429,8.75885417 9.47966667,10.3929687 11.5,10.3929687 C13.5203333,10.3929687 15.1637857,8.75885417 15.1637857,6.75 C15.1637857,4.74114583 13.5200714,3.10703125 11.5,3.10703125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Views-Notifications",
    transform: "translate(-188.000000, -581.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(182.000000, 569.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/view",
    transform: "translate(6.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icFooterView",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFooterView);
export default __webpack_public_path__ + "static/media/icFooterView.1df35b38a4b1e447c6c89ae0a17bc112.svg";
export { ForwardRef as ReactComponent };